import clsx from "clsx";
import React, { useEffect, useState } from "react";
import ModalAction from "../../components/ModalAction";
import ModalSkeleton from "../../components/ModalSkeleton";
import OtpInput from "../../components/OtpInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import classes from "./VerifyOtp.module.css";

const otpVerificationSchema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP is required")
    .matches(/^[0-9]{6}$/, "Must be exactly 6 digits"),
});

const OtpVerificationModal = ({
  onSubmit,
  setShow,
  otpVerified,
  show,
  loading,
}) => {
  // Initialize timer for 5 minutes (300 seconds)
  const [timeLeft, setTimeLeft] = useState(300);

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: otpVerificationSchema,
    onSubmit: (values) => {
      if (typeof onSubmit === "function") {
        // onSubmit({ otpCode: values.otp }, () => {
        //   resetForm();
        //   setShow(false);
        // });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    resetForm,
    isValid,
    dirty,
  } = formik;

  const handleResendOtp = () => {
    resetForm();
    setTimeLeft(300); // Reset timer to 5 minutes
  };

  useEffect(() => {
    let timer;
    if (timeLeft > 0) {
      timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [timeLeft]);

  useEffect(() => {
    if (values.otp?.length === 6) {
      onSubmit({ otpCode: values.otp }, onCancel);
    }
  }, [values.otp]);

  const onCancel = () => {
    setShow(false);
    resetForm();
  };

  // Button is disabled if form is invalid or not dirty
  const isButtonDisabled = !isValid || !dirty || loading;

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  let timeAndResendContent;
  if (otpVerified) {
    timeAndResendContent = null;
  } else if (!otpVerified && timeLeft > 0) {
    timeAndResendContent = (
      <span className={clsx(classes.indicator)}>
        Resend OTP in {formatTime(timeLeft)}
      </span>
    );
  } else {
    timeAndResendContent = (
      <span
        className={clsx(classes.indicator, classes.resendAction)}
        onClick={handleResendOtp}
      >
        Resend Now
      </span>
    );
  }

  return (
    <ModalSkeleton
      width="500px"
      title="Verification Code"
      show={show}
      setShow={setShow}
      actions={false}
    >
      <form onSubmit={handleSubmit}>
        <p className={classes.note}>
          We are automatically detecting a SMS sent to your Email
        </p>
        <OtpInput
          value={values.otp}
          onChange={(value) => {
            setFieldValue("otp", value);
            setFieldTouched("otp", true, false);
          }}
          error={touched?.otp && errors.otp}
          isVerified={otpVerified}
        />
        <div className={classes.waitAndAction}>{timeAndResendContent}</div>
        <ModalAction
          disabled={isButtonDisabled}
          type="submit"
          isApiCall={loading}
          className={classes.bottomCtas}
          onCancel={onCancel}
        />
      </form>
    </ModalSkeleton>
  );
};

export default OtpVerificationModal;
